/**
 * author: duxin
 * date: 2020/4/3
 * describe:
 */

import VueRouter from "vue-router"
import vue from "vue"

vue.use(VueRouter);
const routes = [
    {
        path: '/',
        component: () => import('../views/index.vue'),
        redirect: "/home",
        children: [
            {
                path: 'home',
                component: () => import('../views/home/index.vue'),
            },
            {
                path: 'service',
                component: () => import('../views/service/index.vue'),
                redirect: "/service/clinical",
                children: [
                    {
                        path: 'clinical',
                        name: 'CLINICAL',
                        component: () => import('../views/service/clinical.vue'),
                    },
                    {
                        path: 'call',
                        name: 'CALL',
                        component: () => import('../views/service/call.vue'),
                    },
                    {
                        path: 'medical',
                        name: 'MEDICAL',
                        component: () => import('../views/service/medical.vue'),
                    },
                    {
                        path: 'affairs',
                        name: 'AFFAIRS',
                        component: () => import('../views/service/affairs.vue'),
                    },
                    {
                        path: 'partner',
                        name: 'PARTNER',
                        component: () => import('../views/service/partner.vue'),
                    },
                    {
                        path: 'FSP',
                        name: 'FSP',
                        component: () => import('../views/service/FSP.vue'),
                    },
                    {
                        path: 'auditing',
                        name: 'AUDITING',
                        component: () => import('../views/service/auditing.vue'),
                    },
                    {
                        path: 'drug',
                        name: 'DRUG',
                        component: () => import('../views/service/drug.vue'),
                    },
                    {
                        path: 'food',
                        name: 'FOOD',
                        component: () => import('../views/service/food.vue'),
                    },
                    {
                        path: 'management',
                        name: 'MANAGEMENT',
                        component: () => import('../views/service/management.vue'),
                    },
                    {
                        path: 'patient',
                        name: 'PATIENT',
                        component: () => import('../views/service/patient.vue'),
                    },
                    {
                        path: 'pharmaceutical',
                        name: 'PHARMACEUTICAL',
                        component: () => import('../views/service/pharmaceutical.vue'),
                    },
                    {
                        path: 'diagnosis',
                        name: 'DIAGNOSIS',
                        component: () => import('../views/service/diagnosis.vue'),
                    },
                ]
            },
            {
                path: 'about',
                redirect: "/about/company",
                component: () => import('../views/about/index.vue'),
                children:[
                    {
                        path: 'company',
                        component: () => import('../views/about/company.vue'),
                    },
                    {
                        path: 'children',
                        component: () => import('../views/about/children.vue'),
                    },
                ]
            },
            {
                path: 'join',
                redirect: "/join/joinus",
                component: () => import('../views/join/index.vue'),
                children: [
                    {
                        path: 'joinus',
                        name: 'JOINUS',
                        component: () => import('../views/join/join-us.vue'),
                    },
                    {
                        path: 'detail',
                        name: 'DETAIL',
                        component: () => import('../views/join/detail.vue'),
                    },
                    {
                        path: 'application',
                        name: 'APPLICATION',
                        component: () => import('../views/join/application.vue'),
                    },
                ]
            },
            {
                path: 'contact',
                name: 'contact',
                component: () => import('../views/contact/contact-us.vue'),
            },
            {
                path: 'info',
                redirect: "/info/company",
                component: () => import('../views/information/index.vue'),
                children:[
                    {
                        path: 'company',
                        name: 'COMPANY',
                        component: () => import('../views/information/company.vue'),
                    },
                    {
                        path: 'industry',
                        name: 'INDUSTRY',
                        component: () => import('../views/information/industry.vue'),
                    },
                    {
                        path: 'book',
                        name: 'BOOK',
                        component: () => import('../views/information/books.vue'),
                    },
                    {
                        path: 'web',
                        name: 'WEB',
                        component: () => import('../views/information/web-page.vue'),
                    }
                ]
            },
        ]
    },
    { // 404
        path: '*',
        name: 'Error',
        meta: {
            title: '404-页面不存在'
        },
        component: () => import('../views/error'),
    }
];


export default new VueRouter({
    routes,
    mode: 'history',
    base: process.env.BASE_URL,
});